import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/competition";

/**
 * The competitions list. Paged by the search endpoint, the only read the warehouse
 * offers, and read on arrival as the legacy table did. The table has no state column.
 */
export const competitionsListDefinition: ListDefinition = {
  path: "/competitions",
  entityName: "dwcompetition",
  recordRoute,
  title: "Competitions",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads this key from a case-sensitive dictionary.
  filters: [{ name: "name", label: "Name", kind: "text", width: "wide" }],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: false,
  allowDelete: true,
  deleteRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
